import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { AcceptedOnDevice, TaskState } from '@modules/TasksModule/types';
import InboxModule from '..';
import { setCallToAccepted } from '../callHandlers/callStateHandler';
import { phoneState } from '@modules/SoftPhoneModule/state';
import { assert } from '@lib/utils/assert';
import { authState } from '@modules/AuthModule/state';
import { hasCachedCall } from '@modules/SoftPhoneModule/lib/calls';

function handleSessionDelivered(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  const { user } = authState;
  const userId = user?.id;
  if (!!userId && event.userId !== userId) {
    return;
  }

  const task = TasksModule.getTask(event.sessionSid);

  if (!task) {
    context.logger.error(
      'Task not found for session in `handleSessionDelivered`',
      event,
    );
    return;
  }

  if (!InboxModule.isDid(task) && event.userId === context.userId) {
    // if it is a queue call and the session event is for the current user

    assert(
      task.state === TaskState.Offered,
      'Queue Tasks should be in OFFERED state',
    );

    // get the remote call id from the call state
    const call = phoneState.callList.find(
      (call) => call.callId === task.attributes.callId,
    );

    let remoteCallId: string | undefined;
    let acceptedOn: AcceptedOnDevice = AcceptedOnDevice.ThisDevice;

    if (call) {
      remoteCallId = call.remoteCallId;
      acceptedOn = AcceptedOnDevice.ThisDevice; // Call found in callList means it was accepted on this device
    } else if (hasCachedCall(task.attributes.callId)) {
      // Fallback to cache for mobile-accepted calls
      // When a call is accepted via mobile app, the webphone receives a call-failed event
      // and the call is removed from callList before session.delivered is processed
      // This essentially means that the call came in from the webphone as well, but it got accepted elsewhere.
      acceptedOn = AcceptedOnDevice.OtherDevice;
      context.logger.info(
        `Using cached call data for mobile-accepted call: ${task.attributes.callId}`,
      );
    } else {
      // Call did not come in from the webphone at all.
      acceptedOn = AcceptedOnDevice.OtherDevice;
    }

    // set the task to accepted
    setCallToAccepted(context, event.sessionSid, remoteCallId, acceptedOn);
  }
}

export default handleSessionDelivered;
